// Mapa PURO: pathname da origem → focusKey SEMPRE montado da tela (o item de
// TopNav `nav-*`). É a `restoreSafeKey` que a camada de ficha carrega: quando o
// overlay fecha e o card exato sumiu (virtualizado pra fora), o `startEntryFocus`
// cai NESTE alvo em vez de deixar o D-pad morto (docs/plan/tv-ficha-overlay.md §6).
//
// Função pura (sem DOM, sem router) — testável em node e chamável tanto do call
// site do card quanto do shim de deep-link. Recebe o pathname JÁ sem basename
// (o de `useLocation()` do react-router, não `window.location.pathname`, que na
// TV empacotada carrega o diretório de instalação).

// As telas de origem de onde um card de FILME pode ser aberto. O primeiro
// segmento do path bate 1:1 com a `key` do item de TopNav (`nav-${key}`), então
// a whitelist é o próprio conjunto de segmentos conhecidos — nada de `nav-<lixo>`
// pra um path inesperado.
const KNOWN_ORIGIN_SEGMENTS = new Set<string>([
  'home',
  'movies',
  'series',
  'search',
  'live',
  'epg',
  'replay',
])

/** A rede de segurança quando o segmento é desconhecido: o Home sempre existe. */
export const DEFAULT_SAFE_KEY = 'nav-home'

/**
 * Deriva o `nav-*` da origem a partir do pathname. Ex.: `/movies` → `nav-movies`,
 * `/movies/curated/abc` → `nav-movies`, `/home/curated/x` → `nav-home`,
 * `/` ou desconhecido → `nav-home`.
 */
export function safeKeyForOrigin(pathname: string | null | undefined): string {
  if (!pathname) return DEFAULT_SAFE_KEY
  // Primeiro segmento não-vazio (tolera basename já removido, barra dupla, etc).
  const seg = pathname.split('/').find((s) => s.length > 0)
  if (seg && KNOWN_ORIGIN_SEGMENTS.has(seg)) return `nav-${seg}`
  return DEFAULT_SAFE_KEY
}
